/** Angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { DefectInfo } from '../models/defect-info';

@Injectable({
  providedIn: 'root',
})
export class BydDefectsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService.
   */
  path: string;

  /**
   * Get project defects.
   *
   * @param projectId the project id
   * @returns Observable<DefectInfo>
   */
  public getDefects(projectId: number): Observable<DefectInfo> {
    this.path = `/projects/${projectId}/defects`;
    return this.getModel<DefectInfo>();
  }

  /**
   * Add enabled defect lot.
   *
   * @param projectId the project id
   * @param lotId the lot id
   * @param campaignId the campaign id
   * @returns  Observable<boolean>
   */
  public addEnabledDefectLot(projectId: number, lotId: number, campaignId: number): Observable<boolean> {
    this.path = `/projects/${projectId}/defects`;
    const body = JSON.stringify({ lotid: lotId, campaignid: campaignId });
    return this.post({ body });
  }

  /**
   * Remove enabled defect lot.
   *
   * @param projectId the project id
   * @param lotId the lot id
   * @param campaignId the campaign id
   * @returns  Observable<boolean>
   */
  public removeEnabledDefectLot(projectId: number, lotId: number, campaignId: number): Observable<boolean> {
    this.path = `/projects/${projectId}/defects/${campaignId}/${lotId}`;
    return this.delete();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   *
   * @param jsonObject the defect informations
   * @returns DefectInfo
   */
  public createNewInstance(jsonObject: DefectInfo): DefectInfo {
    return new DefectInfo(jsonObject);
  }
}
